import React, { Component } from "react";
import {
  Form,
  Card,
  Button,
  Row,
  Col,
  Alert,
  Modal,
  Spinner,
  Badge,
  Table,
} from "react-bootstrap";
import { toast } from "react-toastify";
import configData from "../config.json";
import DataTable from "react-data-table-component";

import LoadingOverlay from "./LoadingOverlay";
export default class Generatebulkquote extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      userName: sessionStorage.getItem("userName"),
      // Company & Employee Data
      selectedCompany: "",
      companies: [],
      healthmemberdata: [],
      universaladdons: [],
      caresupremeaddons: [],
      companyStats: {
        totalEmployees: 0,
        totalAdults: 0,
        totalChildren: 0,
        totalParents: 0,
      },
      // Insurance Product Data
      selectedInsurer: "",
      selectedProduct: "",
      insurers: [],
      products: [],
      // User-defined limits
      maxAdults: "",
      maxChildren: "",
      maxParents: "",
      // Bulk Quote Configuration
      selectedSumInsured: "",
      sumInsuredOptions: [
        { value: "500000", label: "₹5,00,000" },
        { value: "1000000", label: "₹10,00,000" },
        { value: "1500000", label: "₹15,00,000" },
        { value: "2000000", label: "₹20,00,000" },
        { value: "2500000", label: "₹25,00,000" },
        { value: "3000000", label: "₹30,00,000" },
        { value: "5000000", label: "₹50,00,000" },
        { value: "10000000", label: "₹1,00,00,000" },
      ],
      // Bulk Configuration
      bulkSumInsuredConfig: {
        applyToAll: true,
        allEmployeesSumInsured: "",
        customConfig: {},
      },
      // Bulk Add-ons Configuration
      bulkAddonsConfig: {
        applyToAll: true,
        allEmployeesAddons: {
          maternityCover: false,
          opdCover: false,
          dentalCover: false,
          lifeCover: false,
          criticalIllnessCover: false,
        },
        memberSpecificAddons: {
          adults: {
            maternityCover: false,
            opdCover: false,
            dentalCover: false,
            lifeCover: false,
            criticalIllnessCover: false,
          },
          children: {
            maternityCover: false,
            opdCover: false,
            dentalCover: false,
            lifeCover: false,
            criticalIllnessCover: false,
          },
          parents: {
            maternityCover: false,
            opdCover: false,
            dentalCover: false,
            lifeCover: false,
            criticalIllnessCover: false,
          },
        },
      },
      // Legacy - keeping for backward compatibility
      selectedAddons: {
        maternityCover: false,
        opdCover: false,
        dentalCover: false,
        lifeCover: false,
        criticalIllnessCover: false,
      },
      // UI State
      showAdvancedConfig: false,
      bufferPercentage: 10,
      // Processing state
      isProcessing: false,
      loading: false,
      showResultsModal: false,
      quoteResults: null,
      // Data table
      data: [],
      filteredData: null,
      itemsPerPage: 100,
      selectedRows: [],
      tableClms: [
        {
          name: (
            <input
              type="checkbox"
              onChange={(e) => this.handleSelectAll(e.target.checked)}
            />
          ),
          cell: (row) => (
            <input
              type="checkbox"
              checked={this.state.selectedRows.includes(
                row.healthmemberdata_Id
              )}
              onChange={(e) =>
                this.handleRowSelect(row.healthmemberdata_Id, e.target.checked)
              }
            />
          ),
        },
        {
          name: "EMPLOYEE ID",
          selector: (row, i) => row.employeeid,
          sortable: true,
          cell: (row) => <span>{row.employeeid}</span>,
        },
        {
          name: "MEMBER NAME",
          selector: (row, i) => row.memberfullname,
          sortable: true,
          cell: (row) => <span>{row.memberfullname}</span>,
        },
        {
          name: "RELATIONSHIP",
          selector: (row, i) => row.relationwithemployee,
          sortable: true,
          cell: (row) => <span>{row.relationwithemployee}</span>,
        },
        {
          name: "DATE OF BIRTH",
          selector: (row, i) => row.dob,
          sortable: true,
          cell: (row) => <span>{row.dob}</span>,
        },
        {
          name: "GENDER",
          selector: (row, i) => row.gender,
          sortable: true,
          cell: (row) => <span>{row.gender}</span>,
        },
        {
          name: "PINCODE",
          selector: (row, i) => row.pincode,
          sortable: true,
          cell: (row) => <span>{row.pincode}</span>,
        },
        {
          name: "SUM INSURED",
          selector: (row) => row.suminsured,
          sortable: true,
          cell: (row, index) => (
            <Form.Select
              value={row.suminsured ?? ""}
              onChange={(e) =>
                this.handleSumInsuredChange(e, row.healthmemberdata_Id)
              }
              style={{ width: "120px" }}
            >
              <option value="">Select</option>
              {this.getCompanySumInsuredOptions().map((amt, idx) => (
                <option key={idx} value={amt}>
                  {amt}
                </option>
              ))}
            </Form.Select>
          ),
        },
      ],
      selectedRelation: "",
      selectedGender: "",
      showBulkModal: false,
      bulkSelectedSumInsured: "",
      availableProducts: [], // product API
      selectedProductId: "",
      selectedPlanType: "",
      zonestatus: [],
      companyId: "",
      insurer: "",
      productName: "",
      productSubCategory: "",
      bulkQuoteRequestStatus: "",
      buffer: "",
      memberId: "",
      gender: "",
      dob: "",
      relationshipWithEmployee: "",
      pincode: "",
      premium: "",
      sumInsured: "",
      premiumGenerationStatus: "",
      bulkquoteRequestId: "",
      employeeId: "",
      memberFullName: "",
      Zone: "",
      memberCoverageStatus: "",
      coverageFamilyDefinition: "",
      setZoneStatus: "",
      setPremiumStatus: "",
      setAgeStatus: "",
      adultsCount: "",
      childrenCount: "",
      parentsCount: "",
      eldestAge: "",
      addonCode: "",
      addonValue: "",
      addonPremium: "",
      zone: "",
      bulkQuoteRequestId: "",
      addonName: "",
      addonTotalPremium: "",
      totalBasePremium: "",
      maternityAddonTotal: "",
      diabetisOne: "",
      total: "",
      gst: "",
      grandTotal: "",
      totalMembers: "",
      totalAdults: "",
      totalChildren: "",
      totalParents: "",
      quoteGenerationDate: "",
      quoteRequestedBy: "",
      bufferAmount: "",
    };
  }
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };
  //checkbox
  handleRowSelect = (rowId, checked) => {
    this.setState((prev) => {
      const updated = checked
        ? [...prev.selectedRows, rowId]
        : prev.selectedRows.filter((id) => id !== rowId);
      return { selectedRows: updated };
    });
  };

  handleSelectAll = (checked) => {
    if (checked) {
      // ✅ Get filtered company data instead of all healthmemberdata
      let filteredCompanyData = this.state.selectedCompany
        ? this.state.healthmemberdata.filter(
          (m) => m.companyid === this.state.selectedCompany
        )
        : [];

      // Apply existing filters
      if (this.state.filterRelation) {
        filteredCompanyData = filteredCompanyData.filter(
          (m) => m.relationwithemployee === this.state.filterRelation
        );
      }
      if (this.state.filterGender) {
        filteredCompanyData = filteredCompanyData.filter(
          (m) => m.gender === this.state.filterGender
        );
      }
      if (this.state.filterEmployeeId) {
        filteredCompanyData = filteredCompanyData.filter(
          (m) => m.employeeid === this.state.filterEmployeeId
        );
      }
      if (this.state.filterMemberName) {
        filteredCompanyData = filteredCompanyData.filter(
          (m) => m.memberfullname === this.state.filterMemberName
        );
      }
      if (this.state.filterSumInsured) {
        filteredCompanyData = filteredCompanyData.filter(
          (m) => m.suminsured === this.state.filterSumInsured
        );
      }
      if (this.state.filterDob) {
        filteredCompanyData = filteredCompanyData.filter(
          (m) => m.dob?.trim() === this.state.filterDob
        );
      }

      const allIds = filteredCompanyData.map((row) => row.healthmemberdata_Id);
      this.setState({ selectedRows: allIds });
    } else {
      this.setState({ selectedRows: [] });
    }
  };
  // Get all unique suminsured values for selected company
  getCompanySumInsuredOptions = () => {
    const { selectedCompany, healthmemberdata } = this.state;
    if (!selectedCompany) return [];
    const companyMembers = healthmemberdata.filter(
      (m) => m.companyid === selectedCompany
    );
    // Collect all unique suminsured values from company members
    const options = [
      ...new Set(companyMembers.map((m) => m.suminsured).filter(Boolean)),
    ];
    return options;
  };

  handleSumInsuredChange = (e, rowId) => {
    const value = e?.target?.value ?? "";
    this.setState((prev) => {
      const newData = prev.healthmemberdata.map((r) =>
        String(r.healthmemberdata_Id) === String(rowId)
          ? { ...r, suminsured: value }
          : r
      );
      return { healthmemberdata: newData };
    });
  };

  handleAddonToggle = (rowId, addonId, checked) => {
    this.setState((prevState) => {
      const newData = prevState.healthmemberdata.map((r) => {
        if (String(r.healthmemberdata_Id) === String(rowId)) {
          let updatedAddons = Array.isArray(r.addons) ? [...r.addons] : [];
          if (checked) {
            if (!updatedAddons.includes(addonId)) {
              updatedAddons.push(addonId);
            }
          } else {
            updatedAddons = updatedAddons.filter((id) => id !== addonId);
          }
          return { ...r, addons: updatedAddons };
        }
        return r;
      });
      return { healthmemberdata: newData };
    });
  };

  componentDidMount() {
    this.fetchCompanies();
    this.fetchInsurers();
    this.HealthmembertotaldatafetchHandler();
    this.HealthsicodesfetchHandler();
    this.CaresupremeaddonsfetchHandler();
  }
  CaresupremeaddonsfetchHandler = (productName) => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Caresupremeaddons/list", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          // this.setState({ caresupreme: data.list });
          const filteredAddons = data.list.filter(
            (addon) => addon.productName === productName
          );
          this.setState({ caresupremeaddons: filteredAddons });
        }
      });
  };
  HealthsicodesfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Healthsicodes/list", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ universaladdons: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  };
  // Fetch companies from company table
  // fetchCompanies = async () => {
  //   try {
  //     const formData = new FormData();
  //     formData.append("sId", this.state.sId);
  //     formData.append("uId", this.state.uId);

  //     const response = await fetch(configData.api_url + "C_company/list", {
  //       method: "POST",
  //       mode: "cors",
  //       body: formData,
  //     });

  //     const data = await response.json();
  //     if (data.status === "success") {
  //       this.setState({ companies: data.list });
  //     } else {
  //       toast.error("Failed to fetch companies");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching companies:", error);
  //     toast.error("Error fetching companies");
  //   }
  // };
  fetchCompanies = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Company/list", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ companies: data.list });
        }
      });
  };
  // Fetch insurers from healthproducts table
  fetchInsurers = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Healthproducts/list", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          const uniqueInsurers = [
            ...new Set(data.list.map((item) => item.insurername)),
          ];
          this.setState({ data: data.list });
          this.setState({
            insurers: uniqueInsurers.map((insurer) => ({ name: insurer })),
            products: data.list,
          });
        } else {
          toast.error("Failed to fetch insurers");
        }
      });
  };
  //healthmemberdata list
  HealthmembertotaldatafetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Healthmemberdata/list", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          // ensure each row has its own addons array and suminsured default
          const rows = (data.list || []).map((r, idx) => ({
            ...r,
            addons: Array.isArray(r.addons) ? [...r.addons] : [], // safe per-row array
            suminsured: r.suminsured ?? "",
            // keep healthmemberdata_Id if present; otherwise fallback to memberid/employeeid
            healthmemberdata_Id:
              r.healthmemberdata_Id ?? r.memberid ?? r.employeeid ?? `r_${idx}`,
          }));
          this.setState({ healthmemberdata: rows });
        }
      })
      .catch((err) => {
        console.error("Healthmember fetch error", err);
      });
  };

  // fetchInsurers = async () => {
  //   try {
  //     const formData = new FormData();
  //     formData.append("sId", this.state.sId);
  //     formData.append("uId", this.state.uId);

  //     const response = await fetch(
  //       configData.api_url + "C_healthproducts/list",
  //       {
  //         method: "POST",
  //         mode: "cors",
  //         body: formData,
  //       }
  //     );

  //     const data = await response.json();
  //     if (data.status === "success") {
  //       // Get unique insurers from healthproducts
  //       const uniqueInsurers = [
  //         ...new Set(data.list.map((item) => item.insurername)),
  //       ];
  //       this.setState({
  //         insurers: uniqueInsurers.map((insurer) => ({ name: insurer })),
  //         products: data.list,
  //       });
  //     } else {
  //       toast.error("Failed to fetch insurers");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching insurers:", error);
  //     toast.error("Error fetching insurers");
  //   }
  // };

  // Fetch employee counts for selected company
  fetchCompanyStats = async (companyId) => {
    if (!companyId) {
      this.setState({
        companyStats: {
          totalEmployees: 0,
          totalAdults: 0,
          totalChildren: 0,
          totalParents: 0,
        },
      });
      return;
    }

    try {
      const formData = new FormData();
      formData.append("sId", this.state.sId);
      formData.append("uId", this.state.uId);
      formData.append("companyid", companyId);

      const response = await fetch(
        configData.api_url + "C_Healthmemberdata/get_company_status_counts",
        {
          method: "POST",
          mode: "cors",
          body: formData,
        }
      );

      const data = await response.json();
      if (data.status === "success" && data.counts) {
        this.setState({
          companyStats: {
            totalEmployees: data.counts.total_employees || 0,
            totalAdults: data.counts.total_adults || 0,
            totalChildren: data.counts.total_children || 0,
            totalParents: data.counts.total_parents || 0,
          },
        });
      } else {
        // If no specific endpoint exists, try to get employee list and calculate
        this.fetchEmployeeList(companyId);
      }
    } catch (error) {
      console.error("Error fetching company stats:", error);
      // Fallback: try to get employee list
      this.fetchEmployeeList(companyId);
    }
  };

  // Fallback method to get employee list and calculate stats
  fetchEmployeeList = async (companyId) => {
    try {
      const formData = new FormData();
      formData.append("sId", this.state.sId);
      formData.append("uId", this.state.uId);
      formData.append("companyid", companyId);

      const response = await fetch(
        configData.api_url + "C_Healthmemberdata/get_status1_members",
        {
          method: "POST",
          mode: "cors",
          body: formData,
        }
      );

      const data = await response.json();
      if (data.status === "success") {
        const employees = data.employees || data.list || [];

        let totalEmployees = employees.length;
        let totalAdults = 0;
        let totalChildren = 0;
        let totalParents = 0;

        employees.forEach((emp) => {
          totalAdults += parseInt(emp.noofadults || 0);
          totalChildren += parseInt(emp.noofchildren || 0);
          totalParents += parseInt(emp.noofparents || 0);
        });

        this.setState({
          companyStats: {
            totalEmployees,
            totalAdults,
            totalChildren,
            totalParents,
          },
        });
      }
    } catch (error) {
      console.error("Error fetching employee list:", error);
    }
  };
  //calculation of members
  calculateMemberCounts = () => {
    const { selectedCompany, healthmemberdata } = this.state;

    if (!selectedCompany || !healthmemberdata) return {};

    // Filter only members from selected company
    const members = healthmemberdata.filter(
      (m) => m.companyid === selectedCompany
    );

    let selfCount = 0;
    let spouseCount = 0;
    let sonCount = 0;
    let daughterCount = 0;
    let fatherCount = 0;
    let motherCount = 0;

    members.forEach((m) => {
      const relation = m.relationwithemployee?.toLowerCase();

      if (relation === "self") selfCount++;
      else if (relation === "spouse") spouseCount++;
      else if (relation === "son") sonCount++;
      else if (relation === "daughter") daughterCount++;
      else if (relation === "father") fatherCount++;
      else if (relation === "mother") motherCount++;
    });
    return {
      selfCount,
      spouseCount,
      sonCount,
      daughterCount,
      fatherCount,
      motherCount,
      adults: selfCount + spouseCount,
      children: sonCount + daughterCount,
      parents: fatherCount + motherCount,
      totalMembers: members.length,
    };
  };
  // Event handlers
  handleCompanyChange = (e) => {
    const companyId = e.target.value;
    this.setState({ selectedCompany: companyId });
    this.fetchCompanyStats(companyId);
  };

  handleInsurerChange = (e) => {
    const insurerName = e.target.value;
    this.setState({
      selectedInsurer: insurerName,
      selectedProduct: "", // Reset product selection
    });
  };

  handleProductChange = (e) => {
    const selectedProductName = e.target.value;

    // Find product object from productname
    const selectedProductObj = this.state.products.find(
      (p) => p.productname === selectedProductName
    );

    // Take productcode (matches Healthsicodes.productid)
    const selectedProductId = selectedProductObj
      ? selectedProductObj.productcode
      : "";

    this.setState(
      {
        selectedProduct: selectedProductName,
        selectedProductId: selectedProductId,
      },
      () => {
        this.CaresupremeaddonsfetchHandler(selectedProductName);
        this.HealthsicodesfetchHandler();
      }
    );
  };

  getProductsForSelectedInsurer = () => {
    if (!this.state.selectedInsurer) return [];

    return this.state.products.filter(
      (product) => product.insurername === this.state.selectedInsurer
    );
  };
  handleBulkUpdateSumInsured = () => {
    const { bulkSelectedSumInsured, selectedCompany, healthmemberdata } =
      this.state;

    if (!bulkSelectedSumInsured) {
      toast.warning("Please select a sum insured to apply.");
      return;
    }
    const updatedData = healthmemberdata.map((member) =>
      member.companyid === selectedCompany
        ? { ...member, suminsured: bulkSelectedSumInsured }
        : member
    );
    this.setState({
      healthmemberdata: updatedData,
      showBulkModal: false, // close modal after applying
      bulkSelectedSumInsured: "", // reset
    });
  };

  handleAddonChange = (addonName) => {
    this.setState((prevState) => ({
      selectedAddons: {
        ...prevState.selectedAddons,
        [addonName]: !prevState.selectedAddons[addonName],
      },
    }));
  };

  // Bulk Sum Insured Handlers
  handleBulkSumInsuredToggle = (applyToAll) => {
    this.setState((prevState) => ({
      bulkSumInsuredConfig: {
        ...prevState.bulkSumInsuredConfig,
        applyToAll: applyToAll,
      },
    }));
  };

  handleBulkSumInsuredChange = (value) => {
    this.setState((prevState) => ({
      bulkSumInsuredConfig: {
        ...prevState.bulkSumInsuredConfig,
        allEmployeesSumInsured: value,
      },
      selectedSumInsured: value, // For backward compatibility
    }));
  };

  // Bulk Add-ons Handlers
  handleBulkAddonsToggle = (applyToAll) => {
    this.setState((prevState) => ({
      bulkAddonsConfig: {
        ...prevState.bulkAddonsConfig,
        applyToAll: applyToAll,
      },
    }));
  };

  handleBulkAddonsChange = (addonName, checked) => {
    this.setState((prevState) => ({
      bulkAddonsConfig: {
        ...prevState.bulkAddonsConfig,
        allEmployeesAddons: {
          ...prevState.bulkAddonsConfig.allEmployeesAddons,
          [addonName]: checked,
        },
      },
      selectedAddons: {
        ...prevState.selectedAddons,
        [addonName]: checked,
      },
    }));
  };

  handleMemberSpecificAddonsChange = (memberType, addonName, checked) => {
    this.setState((prevState) => ({
      bulkAddonsConfig: {
        ...prevState.bulkAddonsConfig,
        memberSpecificAddons: {
          ...prevState.bulkAddonsConfig.memberSpecificAddons,
          [memberType]: {
            ...prevState.bulkAddonsConfig.memberSpecificAddons[memberType],
            [addonName]: checked,
          },
        },
      },
    }));
  };

  handleApplyBulkAddonsToAll = () => {
    const { allEmployeesAddons } = this.state.bulkAddonsConfig;
    this.setState((prevState) => ({
      bulkAddonsConfig: {
        ...prevState.bulkAddonsConfig,
        memberSpecificAddons: {
          adults: { ...allEmployeesAddons },
          children: { ...allEmployeesAddons },
          parents: { ...allEmployeesAddons },
        },
      },
    }));
    toast.success("Add-ons applied to all member types");
  };

  // Validation
  validateForm = () => {
    if (!this.state.selectedCompany) {
      toast.error("Please select a company");
      return false;
    }
    if (!this.state.selectedInsurer) {
      toast.error("Please select an insurer");
      return false;
    }
    if (!this.state.selectedProduct) {
      toast.error("Please select a product");
      return false;
    }
    if (
      !this.state.selectedSumInsured &&
      !this.state.bulkSumInsuredConfig.allEmployeesSumInsured
    ) {
      toast.error("Please configure sum insured amount");
      return false;
    }
    if (
      !this.state.maxAdults ||
      !this.state.maxChildren ||
      !this.state.maxParents
    ) {
      toast.error(
        "Please set maximum family limits per employee for adults, children, and parents"
      );
      return false;
    }
    return true;
  };
  handleSubmitClick = (e) => {
    // this.generateBulkQuote();
    // this.BulkquoterequestsubmitHandler();
    //this.BulkquotebasepremiumrequestsubmitHandler();
    // this.BulkquoteaddonrequestsubmitHandler();
    //this.BulkquoteaddonsummarysubmitHandler();
    //this.BulkquotesummarysubmitHandler();
    const companyId = this.state.selectedCompany;
    const member = this.state.healthmemberdata.find(
      (m) => String(m.companyid) === String(companyId)
    );
    const pincode = member && member.pincode ? member.pincode : "";
    this.setZoneapiApiSubmit(companyId, pincode);
  };
  setZoneapiApiSubmit = (companyId, pincode) => {
    var fd = new FormData();
    fd.append("companyId", companyId);
    fd.append("pincode", pincode);
    fd.append("zone", "");

    fetch(configData.api_url + "C_Bulkquotebasepremiumrequest/setZoneAPI", {
      method: "POST",
      headers: {
        // "Content-Type": "application/json",
      },
      mode: "cors",
      body: fd,
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("API Response:", data); // Full response
        if (data.status === "success") {
          const zone = data.data.zone;
          console.log("Zone from API:", zone);

          // Set it in state
          this.setState({ zonestatus: zone }, () => {
            console.log("Zone in state:", this.state.zonestatus);
          });

          // Store in sessionStorage
          sessionStorage.setItem("Zones", zone);
          console.log(
            "Zone in sessionStorage:",
            sessionStorage.getItem("Zone")
          );
          //this.generateBulkQuote();
          this.BulkquoterequestsubmitHandler();
          //this.BulkquotebasepremiumrequestsubmitHandler();
          this.BulkquoteaddonrequestsubmitHandler();
          this.BulkquoteaddonsummarysubmitHandler();
          this.BulkquotesummarysubmitHandler();
        }
      })
      .catch((err) => {
        console.error("Zone API error:", err);
      });
  };

  //bulkquote apis
  BulkquoterequestsubmitHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("companyId", this.state.selectedCompany);
    formData.append("insurer", this.state.selectedInsurer);
    formData.append("productName", this.state.selectedProduct);
    formData.append("productSubCategory", this.state.selectedPlanType);
    formData.append("maxAdults", this.state.maxAdults);
    formData.append("maxParents", this.state.maxParents);
    formData.append("maxChildren", this.state.maxChildren);
    formData.append(
      "bulkQuoteRequestStatus",
      this.state.bulkQuoteRequestStatus
    );
    formData.append("buffer", this.state.bufferPercentage);
    formData.append("bulkquoteRequest_Id", this.state.bulkquoteRequest_Id);
    //***tableData*
    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + "C_Bulkquoterequest/add", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          const bqrId = data.bqrId;
          sessionStorage.setItem("bulkquoteRequestId", bqrId);
          this.setState(
            {
              // bulkquoteRequestId: bqrId,
              companyId: "",
              insurer: "",
              buffer: "",
              productName: "",
              productSubCategory: "",
              maxAdults: "",
              maxParents: "",
              maxChildren: "",
              bulkQuoteRequestStatus: "",
            },
            () => {
              // call second function AFTER bulkquoteRequestId is set
              this.BulkquotebasepremiumrequestsubmitHandler();
            }
          );
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };
  BulkquotebasepremiumrequestsubmitHandler = () => {
    const selectedMembers = this.state.healthmemberdata.filter((row) =>
      this.state.selectedRows.includes(row.healthmemberdata_Id)
    );

    if (selectedMembers.length === 0) {
      this.showToast("No members selected", "error");
      return;
    }

    const zoneFromSession = sessionStorage.getItem("Zones") || "";

    // Prepare bulk data
    const membersData = selectedMembers.map((member) => ({
      memberId: member.healthmemberdata_Id,
      employeeId: member.employeeid,
      memberFullName: member.memberfullname,
      gender: member.gender,
      dob: member.dob,
      relationshipWithEmployee: member.relationwithemployee,
      pincode: member.pincode || "",
      sumInsured: Math.floor(Number(member.suminsured)) || 0,
      familyMember: this.getFamilyMemberCategory(
        member.relationwithemployee,
        member.dob
      ),
    }));

    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("companyId", this.state.selectedCompany);
    formData.append("productName", this.state.selectedProduct);
    formData.append(
      "productSubCategory",
      this.state.selectedPlanType || "Silver"
    );
    formData.append("insurer", this.state.selectedInsurer);
    formData.append("members", JSON.stringify(membersData));
    formData.append("bulkquoteRequestId", this.state.bulkquoteRequestId);
    formData.append("Zone", zoneFromSession);
    formData.append("zone", zoneFromSession);
    formData.append("premium", this.state.premium);
    formData.append(
      "premiumGenerationStatus",
      this.state.premiumGenerationStatus
    );

    // Show loading state
    this.setState({ loading: true });

    fetch(
      configData.api_url + "C_Bulkquotebasepremiumrequest/processBulkPremium",
      {
        method: "POST",
        mode: "cors",
        body: formData,
      }
    )
      .then((res) => res.json())
      .then((data) => {
        // this.setState({ loading: false });

        if (data.status === "success") {
          this.showToast(data.message, "success");

          // Update state with bulk results if needed
          // if (data.data) {
          //   this.setState({
          //     bulkquoteRequestId: data.data.bulkquoteRequestId,
          //     totalBasePremium: data.data.totalBasePremium
          //   });
          // }
          this.setState(
            {
              bulkquoteRequestId: data.data.bulkquoteRequestId,
              totalBasePremium: data.data.totalBasePremium,
            },
            () => {
              // After state is updated, call the next API
              this.BulkquotefedsubmitHandler();
            }
          );
        }
      });
  };
  BulkquotefedsubmitHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("bulkquoteRequestId", this.state.bulkquoteRequestId);
    //***tableData*
    fetch(configData.api_url + "C_Bulkquoteefd/generateEfdEntries", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({ loading: false });
        if (data.status === "success") {
          this.showToast(data.message, "success");
          const quoteResults = {
            bulkQuoteRequestId: data.data.bulkquoteRequestId,
            totalBasePremium: data.data.totalBasePremium,
            processedMembers: data.data.processedMembers,
            totalMembers: data.data.totalMembers, // Use totalMembers from API
            updatedMembers: data.data.updatedMembers,
            totalFamilies: data.data.totalFamilies,
            efdEntriesCreated: data.data.efdEntriesCreated,
            summary: {
              totalBasePremium: data.data.totalBasePremium,
              addonPremiums: 0,
              subTotal: data.data.totalBasePremium,
              gst: Math.round(data.data.totalBasePremium * 0.18),
              buffer: 0,
              grandTotal: Math.round(data.data.totalBasePremium * 1.18),
            },
            memberCounts: {
              adults: data.data.adultsCount || 0,
              children: data.data.childrenCount || 0,
              parents: data.data.parentsCount || 0,
            },
          };

          this.setState({
            quoteResults,
            showResultsModal: true,
            bulkquoteRequestId: data.data.bulkquoteRequestId,
            totalBasePremium: data.data.totalBasePremium,
          });
        } else {
          this.showToast(
            data.message || "Failed to process bulk premium request",
            "error"
          );
          const quoteResults = {
            bulkQuoteRequestId: "-",
            totalBasePremium: 0,
            totalMembers: 0,
            summary: {
              totalBasePremium: 0,
              addonPremiums: 0,
              subTotal: 0,
              gst: 0,
              buffer: 0,
              grandTotal: 0,
            },
            memberCounts: { adults: 0, children: 0, parents: 0 },
            errorMessage: data.message || "Error occurred while processing.",
          };

          this.setState({
            quoteResults,
            showResultsModal: true,
          });
        }
      })
      .catch((err) => {
        console.error("Submit error:", err);
        this.setState({ loading: false });
        this.showToast("Failed to save member data", "error");
        const quoteResults = {
          bulkQuoteRequestId: "-",
          totalBasePremium: 0,
          totalMembers: 0,
          summary: {
            totalBasePremium: 0,
            addonPremiums: 0,
            subTotal: 0,
            gst: 0,
            buffer: 0,
            grandTotal: 0,
          },
          memberCounts: { adults: 0, children: 0, parents: 0 },
          errorMessage: "Network or server error.",
        };

        this.setState({
          quoteResults,
          showResultsModal: true,
        });
      });
  };

  // Helper method to determine family member category
  getFamilyMemberCategory = (relation, dob) => {
    const relationLower = relation?.toLowerCase() || "";

    // Calculate age from DOB if provided
    let age = null;
    if (dob) {
      const today = new Date();
      const birthDate = new Date(dob);
      age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }
    }

    switch (relationLower) {
      case "self":
        return "Self";
      case "spouse":
        return "Spouse";
      case "son":
      case "daughter":
        return age !== null && age < 18 ? "Child" : "Self";
      case "father":
      case "mother":
      case "fatherinlaw":
      case "motherinlaw":
        return "Parent";
      default:
        return "Self";
    }
  };
  BulkquoteaddonrequestsubmitHandler = () => {
    const selectedMembers = this.state.healthmemberdata.filter((row) =>
      this.state.selectedRows.includes(row.healthmemberdata_Id)
    );

    if (selectedMembers.length === 0) {
      this.showToast("No members selected", "error");
      return;
    }

    const zoneFromSession = sessionStorage.getItem("Zones") || "";

    // Collect all addon requests
    const addonRequests = [];
    selectedMembers.forEach((member) => {
      if (Array.isArray(member.addons) && member.addons.length > 0) {
        member.addons.forEach((addonId) => {
          addonRequests.push({
            memberId: member.healthmemberdata_Id,
            employeeId: member.employeeid,
            addonCode: addonId,
            sumInsured: Math.floor(Number(member.suminsured)) || 0,
          });
        });
      }
    });

    if (addonRequests.length === 0) {
      this.showToast("No addons selected for any members", "error");
      return;
    }

    // Ensure bulkquoteRequestId exists - it should be set from premium processing
    if (!this.state.bulkquoteRequestId) {
      this.showToast(
        "Please process premium requests first before adding addons",
        "error"
      );
      this.setState({ loading: false });
      return;
    }

    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("companyId", this.state.selectedCompany);
    formData.append("bulkquoteRequestId", this.state.bulkquoteRequestId);
    formData.append("addonRequests", JSON.stringify(addonRequests));
    formData.append(
      "premiumGenerationStatus",
      this.state.premiumGenerationStatus
    );
    formData.append("zone", zoneFromSession);

    // Show loading state
    this.setState({ loading: true });

    fetch(configData.api_url + "C_Bulkquoteaddonrequest/processBulkAddons", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        this.setState({ loading: false });

        if (data.status === "success") {
          this.showToast(data.message, "success");

          // Update state with bulk results if needed
          if (data.data) {
            console.log("Bulk addon processing completed:", data.data);
          }
        } else {
          this.showToast(
            data.message || "Failed to process bulk addon requests",
            "error"
          );
        }
      })
      .catch((err) => {
        console.error("Addon submit error:", err);
        this.setState({ loading: false });
        this.showToast("Failed to save addon data", "error");
      });
  };
  // BulkquoteaddonsummarysubmitHandler = () => {
  //   const selectedMembers = this.state.healthmemberdata.filter((row) =>
  //     this.state.selectedRows.includes(row.healthmemberdata_Id)
  //   );
  //   // Take addons from selected members
  //   selectedMembers.forEach((member) => {
  //     if (!Array.isArray(member.addons) || member.addons.length === 0) return;
  //     member.addons.forEach((addonId) => {
  //       const formData = new FormData();
  //       formData.append("sId", this.state.sId);
  //       formData.append("uId", this.state.uId);
  //       formData.append("bulkQuoteRequestId", this.state.bulkquoteRequestId);
  //       formData.append("addonName", addonId); // addon name/code
  //       formData.append("addonTotalPremium", this.state.addonTotalPremium || 0);

  //       fetch(configData.api_url + "C_Bulkquoteaddonsummary/add1", {
  //         method: "POST",
  //         mode: "cors",
  //         body: formData,
  //       })
  //         .then((response) => response.json())
  //         .then((data) => {
  //           this.showToast(data.message, data.status);
  //           if (data.status === "success") {
  //             this.BulkquoteaddonsummaryfetchHandler();
  //             this.handleOffcanvasClose();
  //           }
  //         })
  //         .catch((error) => {
  //           console.error("Submit error:", error);
  //           this.showToast("Failed to save addon summary", "error");
  //         });
  //     });
  //   });

  //   // Reset state after processing all addons
  //   this.setState({
  //     bulkQuoteRequestId: "",
  //     addonName: "",
  //     addonTotalPremium: "",
  //   });
  // };
  BulkquoteaddonsummarysubmitHandler = () => {
    const selectedMembers = this.state.healthmemberdata.filter((row) =>
      this.state.selectedRows.includes(row.healthmemberdata_Id)
    );
    // Use a Set to store unique addons across all selected members
    const uniqueAddons = new Set();
    selectedMembers.forEach((member) => {
      if (!Array.isArray(member.addons) || member.addons.length === 0) return;
      member.addons.forEach((addon) => {
        const addonCode = addon.addonCode || addon;
        uniqueAddons.add(addonCode); // Set automatically keeps unique values
      });
    });
    // Submit each unique addon as a separate row
    uniqueAddons.forEach((addon) => {
      const formData = new FormData();
      formData.append("sId", this.state.sId);
      formData.append("uId", this.state.uId);
      formData.append("bulkQuoteRequestId", this.state.bulkquoteRequestId);
      formData.append("addonName", addon);
      formData.append("addonTotalPremium", this.state.addonTotalPremium || 0);

      this.setState({ loading: true, loadingMessage: "Saving..." });
      fetch(configData.api_url + "C_Bulkquoteaddonsummary/add", {
        method: "POST",
        mode: "cors",
        body: formData,
      })
        .then((res) => res.json())
        .then((data) => {
          this.showToast(data.message, data.status);
          if (data.status === "success") {
            this.BulkquoteaddonsummaryfetchHandler();
          }
        
          this.setState({ loading: false });})
        .catch((err) => {
          console.error("Addon summary submit error:", err);
        
          this.setState({ loading: false });});
    });

    // Reset state after processing
    this.setState({
      bulkQuoteRequestId: "",
      addonName: "",
      addonTotalPremium: "",
    });
  };

  BulkquotesummarysubmitHandler = () => {
    var formData = new FormData();
    const counts = this.calculateMemberCounts();
    const today = new Date();
    const quoteGenerationDate = `${today
      .getDate()
      .toString()
      .padStart(2, "0")}/${(today.getMonth() + 1)
        .toString()
        .padStart(2, "0")}/${today.getFullYear()}`;
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("bulkquoteRequestId", this.state.bulkquoteRequestId);
    formData.append("totalBasePremium", this.state.totalBasePremium);
    formData.append("maternityAddonTotal", this.state.maternityAddonTotal);
    formData.append("diabetisOne", this.state.diabetisOne);
    formData.append("total", this.state.total);
    formData.append("gst", this.state.gst);
    formData.append("buffer", this.state.bufferPercentage);
    formData.append("grandTotal", this.state.grandTotal);
    formData.append("totalMembers", counts.totalMembers);
    formData.append("totalAdults", counts.adults);
    formData.append("totalChildren", counts.children);
    formData.append("totalParents", counts.parents);
    formData.append("companyId", this.state.selectedCompany);
    formData.append("quoteGenerationDate", quoteGenerationDate);
    formData.append("quoteRequestedBy", this.state.userName);
    formData.append("bufferAmount", this.state.bufferAmount);
    formData.append("createdBy", this.state.uId);
    //***tableData*

    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + "C_Bulkquotesummary/add", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({
            bulkquoteRequestId: "",
            totalBasePremium: "",
            maternityAddonTotal: "",
            diabetisOne: "",
            total: "",
            gst: "",
            buffer: "",
            grandTotal: "",
            totalMembers: "",
            totalAdults: "",
            totalChildren: "",
            totalParents: "",
            companyId: "",
            quoteGenerationDate: "",
            quoteRequestedBy: "",
            bufferAmount: "",
          });
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };
  // Generate bulk quote
  generateBulkQuote = async () => {
    //if (!this.validateForm()) return;

    // Check if Universal Sompo is selected
    if (
      this.state.selectedInsurer !==
      "Universal Sompo General Insurance Company Limited"
    ) {
      toast.warning(
        "Currently, bulk quote generation is only available for Universal Sompo General Insurance Company Limited"
      );
      return;
    }

    this.setState({ isProcessing: true });

    try {
      const formData = new FormData();
      formData.append("sId", this.state.sId);
      formData.append("uId", this.state.uId);
      formData.append("companyId", this.state.selectedCompany);
      formData.append("insurerName", this.state.selectedInsurer);
      formData.append("productName", this.state.selectedProduct);

      // Use bulk sum insured configuration
      const sumInsured = this.state.bulkSumInsuredConfig.applyToAll
        ? this.state.bulkSumInsuredConfig.allEmployeesSumInsured
        : this.state.selectedSumInsured;
      formData.append("sumInsured", sumInsured);

      formData.append("maxAdults", this.state.maxAdults);
      formData.append("maxChildren", this.state.maxChildren);
      formData.append("maxParents", this.state.maxParents);

      // Use bulk add-ons configuration
      const addonsConfig = this.state.bulkAddonsConfig.applyToAll
        ? this.state.bulkAddonsConfig.allEmployeesAddons
        : this.state.bulkAddonsConfig.memberSpecificAddons;
      formData.append("selectedAddons", JSON.stringify(addonsConfig));
      formData.append(
        "addonsMode",
        this.state.bulkAddonsConfig.applyToAll ? "bulk" : "memberSpecific"
      );

      formData.append("bufferPercentage", this.state.bufferPercentage);
      formData.append(
        "bulkConfiguration",
        JSON.stringify({
          sumInsuredConfig: this.state.bulkSumInsuredConfig,
          addonsConfig: this.state.bulkAddonsConfig,
        })
      );

      const response = await fetch(
        configData.api_url +
        "C_Bulkquotebasepremiumrequest/generateBulkQuoteFromCompany1",
        {
          method: "POST",
          mode: "cors",
          body: formData,
        }
      );

      const data = await response.json();

      if (data.status === "success") {
        this.setState({
          quoteResults: data.data,
          showResultsModal: true,
        });
        toast.success("Bulk quote generated successfully!");
      } else {
        toast.error(data.message || "Failed to generate bulk quote");
      }
    } catch (error) {
      console.error("Error generating bulk quote:", error);
      toast.error("Error generating bulk quote");
    } finally {
      this.setState({ isProcessing: false });
    }
  };
  handleRelationChange = (e) => {
    this.setState({ selectedRelation: e.target.value });
  };

  handleGenderChange = (e) => {
    this.setState({ selectedGender: e.target.value });
  };
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.healthmemberdata.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };
  // Utility: format all DOBs to same string
  formatDob = (dob) => {
    if (!dob) return "";
    const d = new Date(dob);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  render() {
    const {
      companies,
      insurers,
      selectedInsurer,
      isProcessing,
      showResultsModal,
      quoteResults,
      bulkSumInsuredConfig,
      bulkAddonsConfig,
    } = this.state;

    const availableProducts = this.getProductsForSelectedInsurer();
    // const filteredCompanyData = this.state.selectedCompany
    //   ? this.state.healthmemberdata.filter(
    //       (m) => m.companyid === this.state.selectedCompany
    //     )
    //   : [];
    // const filteredCompanyData = this.state.selectedCompany
    //   ? this.state.healthmemberdata.filter((m) => {
    //       let match = m.companyid === this.state.selectedCompany;

    //       if (this.state.selectedRelation) {
    //         match =
    //           match &&
    //           m.relationwithemployee?.toLowerCase() ===
    //             this.state.selectedRelation.toLowerCase();
    //       }

    //       if (this.state.selectedGender) {
    //         match =
    //           match &&
    //           m.gender?.toLowerCase() ===
    //             this.state.selectedGender.toLowerCase();
    //       }

    //       return match;
    //     })
    //   : [];
    const addonColumns = (this.state.caresupremeaddons || []).map((addon) => ({
      name: addon.addOn,
      selector: () => null,
      cell: (row) => (
        <Form.Check
          type="checkbox"
          checked={
            Array.isArray(row.addons) &&
            row.addons.includes(addon.caresupremeaddons_Id)
          }
          onChange={(e) =>
            this.handleAddonToggle(
              row.healthmemberdata_Id,
              addon.caresupremeaddons_Id,
              e.target.checked
            )
          }
        />
      ),
    }));
    const relationOptions = [
      ...new Set(
        this.state.healthmemberdata.map((m) => m.relationwithemployee)
      ),
    ];
    const genderOptions = [
      ...new Set(this.state.healthmemberdata.map((m) => m.gender)),
    ];
    const employeeIdOptions = [
      ...new Set(this.state.healthmemberdata.map((m) => m.employeeid)),
    ];
    const memberNameOptions = [
      ...new Set(this.state.healthmemberdata.map((m) => m.memberfullname)),
    ];
    const sumInsuredOptions = [
      ...new Set(this.state.healthmemberdata.map((m) => m.suminsured)),
    ];
    const dobOptions = [
      ...new Set(this.state.healthmemberdata.map((m) => m.dob?.trim())),
    ];
    let filteredCompanyData = this.state.selectedCompany
      ? this.state.healthmemberdata.filter(
        (m) => m.companyid === this.state.selectedCompany
      )
      : [];

    if (this.state.filterRelation) {
      filteredCompanyData = filteredCompanyData.filter(
        (m) => m.relationwithemployee === this.state.filterRelation
      );
    }
    if (this.state.filterGender) {
      filteredCompanyData = filteredCompanyData.filter(
        (m) => m.gender === this.state.filterGender
      );
    }
    if (this.state.filterEmployeeId) {
      filteredCompanyData = filteredCompanyData.filter(
        (m) => m.employeeid === this.state.filterEmployeeId
      );
    }
    if (this.state.filterMemberName) {
      filteredCompanyData = filteredCompanyData.filter(
        (m) => m.memberfullname === this.state.filterMemberName
      );
    }
    if (this.state.filterSumInsured) {
      filteredCompanyData = filteredCompanyData.filter(
        (m) => m.suminsured === this.state.filterSumInsured
      );
    }
    if (this.state.filterDob) {
      filteredCompanyData = filteredCompanyData.filter(
        (m) => m.dob?.trim() === this.state.filterDob
      );
    }
    const relationColumn = {
      name: (
        <div>
          RELATIONSHIP
          <Form.Select
            size="sm"
            value={this.state.filterRelation || ""}
            onChange={(e) =>
              this.setState({ filterRelation: e.target.value || null })
            }
          >
            <option value="">All</option>
            {relationOptions.map((r, idx) => (
              <option key={idx} value={r}>
                {r}
              </option>
            ))}
          </Form.Select>
        </div>
      ),
      selector: (row) => row.relationwithemployee,
      cell: (row) => <span>{row.relationwithemployee}</span>,
    };

    const genderColumn = {
      name: (
        <div>
          GENDER
          <Form.Select
            size="sm"
            value={this.state.filterGender || ""}
            onChange={(e) =>
              this.setState({ filterGender: e.target.value || null })
            }
          >
            <option value="">All</option>
            {genderOptions.map((g, idx) => (
              <option key={idx} value={g}>
                {g}
              </option>
            ))}
          </Form.Select>
        </div>
      ),
      selector: (row) => row.gender,
      cell: (row) => <span>{row.gender}</span>,
    };
    const employeeIdColumn = {
      name: (
        <div>
          EMPLOYEE ID
          <Form.Select
            size="sm"
            value={this.state.filterEmployeeId || ""}
            onChange={(e) =>
              this.setState({ filterEmployeeId: e.target.value || null })
            }
          >
            <option value="">All</option>
            {employeeIdOptions.map((id, idx) => (
              <option key={idx} value={id}>
                {id}
              </option>
            ))}
          </Form.Select>
        </div>
      ),
      selector: (row) => row.employeeid,
      cell: (row) => <span>{row.employeeid}</span>,
    };

    const memberNameColumn = {
      name: (
        <div>
          MEMBER NAME
          <Form.Select
            size="sm"
            value={this.state.filterMemberName || ""}
            onChange={(e) =>
              this.setState({ filterMemberName: e.target.value || null })
            }
          >
            <option value="">All</option>
            {memberNameOptions.map((name, idx) => (
              <option key={idx} value={name}>
                {name}
              </option>
            ))}
          </Form.Select>
        </div>
      ),
      selector: (row) => row.memberfullname,
      cell: (row) => <span>{row.memberfullname}</span>,
    };

    const sumInsuredColumn = {
      name: (
        <div>
          SUM INSURED
          <Form.Select
            size="sm"
            value={this.state.filterSumInsured || ""}
            onChange={(e) =>
              this.setState({ filterSumInsured: e.target.value || null })
            }
          >
            <option value="">All</option>
            {sumInsuredOptions.map((amt, idx) => (
              <option key={idx} value={amt}>
                {amt}
              </option>
            ))}
          </Form.Select>
        </div>
      ),
      selector: (row) => row.suminsured,
      cell: (row) => (
        <Form.Select
          value={row.suminsured ?? ""}
          onChange={(e) =>
            this.handleSumInsuredChange(e, row.healthmemberdata_Id)
          }
          style={{ width: "120px" }}
        >
          <option value="">Select</option>
          {this.getCompanySumInsuredOptions().map((amt, idx) => (
            <option key={idx} value={amt}>
              {amt}
            </option>
          ))}
        </Form.Select>
      ),
    };
    const dobColumn = {
      name: (
        <div>
          DATE OF BIRTH
          <Form.Select
            size="sm"
            value={this.state.filterDob || ""}
            onChange={(e) =>
              this.setState({ filterDob: e.target.value || null })
            }
          >
            <option value="">All</option>
            {dobOptions.map((dob, idx) => (
              <option key={idx} value={dob}>
                {dob}
              </option>
            ))}
          </Form.Select>
        </div>
      ),
      selector: (row) => row.dob,
      cell: (row) => <span>{this.formatDob(row.dob)}</span>,
    };

    // Replace your old relation + gender columns in tableClms
    const updatedColumns = this.state.tableClms.map((col) => {
      if (col.name === "RELATIONSHIP") return relationColumn;
      if (col.name === "GENDER") return genderColumn;
      if (col.name === "EMPLOYEE ID") return employeeIdColumn;
      if (col.name === "MEMBER NAME") return memberNameColumn;
      if (col.name === "SUM INSURED") return sumInsuredColumn;
      if (col.name === "DATE OF BIRTH") return dobColumn;
      return col;
    });
    return (
      <div className="container-fluid">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-12">
            <h3>Generate Bulk Quote</h3>
          </div>
        </div>

        {/* Company & Product Selection */}
        <div className="row d-flex justify-content-md-center widget_BG mb-3">
          <div className="col-md-12">
            <h6 className="mb-2">Company & Product Selection</h6>
          </div>
          <div className="col-md-3">
            <Form.Group>
              <Form.Label>
                Company Name <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                name="selectedCompany"
                className="form-control"
                value={this.state.selectedCompany}
                onChange={this.handleCompanyChange}
              >
                <option value="">Select a Company</option>
                {companies.map((company) => (
                  <option key={company.companyId} value={company.companyId}>
                    {company.companyName}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </div>
          <div className="col-md-3">
            <Form.Group>
              <Form.Label>
                Insurance Company <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                name="selectedInsurer"
                className="form-control"
                value={this.state.selectedInsurer}
                onChange={this.handleInsurerChange}
              >
                <option value="">Select Insurance Company</option>
                {insurers.map((insurer, index) => (
                  <option key={index} value={insurer.name}>
                    {insurer.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </div>
          <div className="col-md-3">
            <Form.Group>
              <Form.Label>
                Health Product <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                name="selectedProduct"
                className="form-control"
                value={this.state.selectedProduct}
                onChange={this.handleProductChange}
                disabled={!selectedInsurer}
              >
                <option value="">Select Product</option>
                {/* {availableProducts.map((product) => (
                  <option
                    key={product.healthproducts_Id}
                    value={product.productname}
                  >
                    {product.productname}
                  </option>
                ))} */}
                {[
                  ...new Map(
                    availableProducts.map((p) => [p.productname, p])
                  ).values(),
                ].map((product) => (
                  <option
                    key={product.healthproducts_Id}
                    value={product.productname}
                  >
                    {product.productname}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </div>
          <div className="col-md-3">
            <Form.Group>
              <Form.Label>
                Sub Product <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                name="selectedPlanType"
                className="form-control"
                value={this.state.selectedPlanType || ""}
                onChange={(e) =>
                  this.setState({ selectedPlanType: e.target.value })
                }
                disabled={!this.state.selectedProduct}
              >
                <option value="">Select Product</option>
                {this.state.products
                  .filter((p) => p.productname === this.state.selectedProduct)
                  .map((p) => (
                    <option key={p.healthproducts_Id} value={p.plantype}>
                      {p.plantype}
                    </option>
                  ))}
              </Form.Select>
            </Form.Group>
          </div>
        </div>

        {/* Company Overview */}
        <div className="row d-flex justify-content-md-center widget_BG mb-3">
          <div className="col-md-12">
            <h6 className="mb-2">Company Overview</h6>
          </div>
          {(() => {
            const counts = this.calculateMemberCounts();
            return (
              <>
                <div className="row">
                  <div className="col-md-3">
                    <Card className="mb-0 rounded-0 alert alert-primary">
                      <Card.Body className="text-center">
                        <h6>Total&nbsp;Members</h6>
                        <h3>{counts.totalMembers}</h3>
                      </Card.Body>
                    </Card>
                  </div>
                  <div className="col-md-3">
                    <Card className="mb-0 rounded-0 alert alert-primary">
                      <Card.Body className="text-center">
                        <h6>Total&nbsp;Employees</h6>
                        <h3>{counts.selfCount}</h3>
                      </Card.Body>
                    </Card>
                  </div>
                  <div className="col-md-2">
                    <Card className="mb-0 rounded-0 alert alert-success">
                      <Card.Body className="text-center">
                        <h6>Total&nbsp;Adults</h6>
                        <h3>{counts.adults}</h3>
                      </Card.Body>
                    </Card>
                  </div>
                  <div className="col-md-2">
                    <Card className="mb-0 rounded-0 alert alert-info">
                      <Card.Body className="text-center">
                        <h6>Total Children</h6>
                        <h3>{counts.children}</h3>
                      </Card.Body>
                    </Card>
                  </div>
                  <div className="col-md-2">
                    <Card className="mb-0 rounded-0 alert alert-warning">
                      <Card.Body className="text-center">
                        <h6>Total Parents</h6>
                        <h3>{counts.parents}</h3>
                      </Card.Body>
                    </Card>
                  </div>
                </div>
                <div>
                  <Table className="mt-5 table-bordered rounded">
                    <thead>
                      <tr>
                        <th>Self</th>
                        <th>Spouse</th>
                        <th>Son</th>
                        <th>Daughter</th>
                        <th>Mother</th>
                        <th>Father</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{counts.selfCount || 0}</td>
                        <td>{counts.spouseCount || 0}</td>
                        <td>{counts.sonCount || 0}</td>
                        <td>{counts.daughterCount || 0}</td>
                        <td>{counts.fatherCount || 0}</td>
                        <td>{counts.motherCount || 0}</td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </>
            );
          })()}
        </div>

        {/* Family Limits Configuration */}
        <div className="row d-flex justify-content-md-center widget_BG mb-3">
          <div className="col-md-12">
            <h6 className="mb-3">Family Limits Configuration</h6>
          </div>

          <div className="col-md-12">
            <div className="mb-3">
              <Form.Label>
                Maximum Family Limits Per Employee{" "}
                <span className="text-danger">*</span>
              </Form.Label>
              <Form.Text className="text-muted d-block mb-2">
                These limits will be applied to each employee's family
                individually (identified by Employee ID)
              </Form.Text>
              <Row>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="small">
                      Max Adults per Family
                    </Form.Label>
                    <Form.Control
                      type="number"
                      min="1"
                      max="10"
                      value={this.state.maxAdults}
                      onChange={(e) =>
                        this.setState({ maxAdults: e.target.value })
                      }
                      placeholder="Including employee"
                    />
                    <Form.Text className="text-muted small">
                      Employee + Spouse (max)
                    </Form.Text>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="small">
                      Max Children per Family
                    </Form.Label>
                    <Form.Control
                      type="number"
                      min="0"
                      max="10"
                      value={this.state.maxChildren}
                      onChange={(e) =>
                        this.setState({ maxChildren: e.target.value })
                      }
                      placeholder="Per employee family"
                    />
                    <Form.Text className="text-muted small">
                      Dependent children only
                    </Form.Text>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="small">
                      Max Parents per Family
                    </Form.Label>
                    <Form.Control
                      type="number"
                      min="0"
                      max="10"
                      value={this.state.maxParents}
                      onChange={(e) =>
                        this.setState({ maxParents: e.target.value })
                      }
                      placeholder="Per employee family"
                    />
                    <Form.Text className="text-muted small">
                      Father + Mother (max)
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Row>
            </div>
          </div>
        </div>
        <div style={{ marginRight: "5px" }}>
          <p>Members Details</p>
          {/* searchbar,pagination,filter */}
          <input
            type="text"
            onChange={this.handleFilter}
            placeholder="Search..."
            style={{ marginBottom: "10px" }}
          />
          <Button
            variant="primary"
            onClick={() => this.setState({ showBulkModal: true })}
            style={{ float: "right" }}
          >
            Bulk Edit Sum Insured
          </Button>
          <DataTable
            // data={paginatedData}
            // columns={this.state.tableClms}
            data={filteredCompanyData}
            //columns={[...this.state.tableClms, ...addonColumns]}
            columns={[...updatedColumns, ...addonColumns]}
            pagination
            paginationServer
            paginationTotalRows={
              this.state.filteredData
                ? this.state.filteredData.length
                : this.state.data.length
            }
            onChangeRowsPerPage={this.handlePerRowsChange}
            onChangePage={this.handlePageChange}
            paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
            paginationPerPage={100}
            keyField="healthmemberdata_Id"
            paginationRowsPerPageOptions={[10, 20, 30, 50, 60, 70, 80, 90, 100]}
            className="table table-striped table-bordered dataTable no-footer employeesTableIcons mt-3"
          />
          <Modal
            show={this.state.showBulkModal}
            onHide={() => this.setState({ showBulkModal: false })}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Bulk Edit Sum Insured</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Group>
                <Form.Label>Select Sum Insured</Form.Label>
                <Form.Select
                  value={this.state.bulkSelectedSumInsured}
                  onChange={(e) =>
                    this.setState({ bulkSelectedSumInsured: e.target.value })
                  }
                >
                  <option value="">Select</option>
                  {[
                    ...new Set(
                      this.state.universaladdons // fetched from HealthsicodesfetchHandler
                        .filter(
                          (m) => m.productid === this.state.selectedProductId // filter by selected productid
                        )
                        .map((m) => m.sivalue)
                        .filter(Boolean)
                    ),
                  ].map((amt, idx) => (
                    <option key={idx} value={amt}>
                      {amt}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => this.setState({ showBulkModal: false })}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={this.handleBulkUpdateSumInsured}
              >
                Apply
              </Button>
            </Modal.Footer>
          </Modal>
        </div>

        {/* Bulk Add-ons Configuration */}
        <div className="row d-flex justify-content-md-center widget_BG mb-3">
          <div className="col-md-12">
            <h6 className="mb-3">
              <span className="bi bi-plus-square me-2"></span>
              Bulk Add-Ons Configuration
            </h6>
          </div>

          <div className="col-md-8">
            <Card className="border-0 bg-light">
              <Card.Body>
                <div className="mb-4">
                  <Form.Check
                    type="radio"
                    name="addonsMode"
                    label="Apply same Add-ons to all members"
                    checked={bulkAddonsConfig.applyToAll}
                    onChange={() => this.handleBulkAddonsToggle(true)}
                    className="mb-3"
                  />

                  {bulkAddonsConfig.applyToAll && (
                    <div className="ms-4">
                      <Row>
                        {this.state.caresupremeaddons.map((addon) => (
                          <Col md={6} key={addon.caresupremeaddons_Id}>
                            <Form.Group className="d-flex align-items-center mb-2">
                              <Form.Check
                                type="checkbox"
                                checked={
                                  bulkAddonsConfig.allEmployeesAddons[
                                  addon.addOn
                                    .replace(/\s+/g, "")
                                    .toLowerCase()
                                  ] || false
                                }
                                onChange={(e) =>
                                  this.handleBulkAddonsChange(
                                    addon.addOn
                                      .replace(/\s+/g, "")
                                      .toLowerCase(),
                                    e.target.checked
                                  )
                                }
                                className="me-2"
                              />
                              <Form.Label className="mb-0">
                                {addon.addOn}
                              </Form.Label>
                            </Form.Group>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  )}
                </div>

                <div className="mb-0">
                  <Form.Check
                    type="radio"
                    name="addonsMode"
                    label="Configure Add-ons by member type (Advanced)"
                    checked={!bulkAddonsConfig.applyToAll}
                    onChange={() => this.handleBulkAddonsToggle(false)}
                    className="mb-3"
                  />

                  {!bulkAddonsConfig.applyToAll && (
                    <div className="ms-4">
                      <div className="mb-3">
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          onClick={this.handleApplyBulkAddonsToAll}
                          className="mb-3"
                        >
                          <span className="bi bi-arrow-down me-1"></span>
                          Copy from "All Members" selection above
                        </Button>
                      </div>

                      <Row>
                        {["adults", "children", "parents"].map(
                          (memberType, idx) => (
                            <Col md={4} key={memberType}>
                              <h6
                                className={`${idx === 0
                                  ? "text-primary"
                                  : idx === 1
                                    ? "text-success"
                                    : "text-warning"
                                  } small`}
                              >
                                {memberType.charAt(0).toUpperCase() +
                                  memberType.slice(1)}
                              </h6>
                              {this.state.caresupremeaddons.map((addon) => (
                                <Form.Group
                                  key={addon.caresupremeaddons_Id}
                                  className="d-flex align-items-center mb-1"
                                >
                                  <Form.Check
                                    type="checkbox"
                                    checked={
                                      bulkAddonsConfig.memberSpecificAddons[
                                      memberType
                                      ][
                                      addon.addOn
                                        .replace(/\s+/g, "")
                                        .toLowerCase()
                                      ] || false
                                    }
                                    onChange={(e) =>
                                      this.handleMemberSpecificAddonsChange(
                                        memberType,
                                        addon.addOn
                                          .replace(/\s+/g, "")
                                          .toLowerCase(),
                                        e.target.checked
                                      )
                                    }
                                    className="me-2"
                                    size="sm"
                                  />
                                  <Form.Label className="mb-0 small">
                                    {addon.addOn}
                                  </Form.Label>
                                </Form.Group>
                              ))}
                            </Col>
                          )
                        )}
                      </Row>
                    </div>
                  )}
                </div>
              </Card.Body>
            </Card>
          </div>

          <div className="col-md-4">
            <Form.Group>
              <Form.Label>Buffer Percentage (%)</Form.Label>
              <Form.Control
                type="number"
                min="0"
                max="100"
                step="0.5"
                value={this.state.bufferPercentage}
                onChange={(e) =>
                  this.setState({
                    bufferPercentage: parseFloat(e.target.value) || 0,
                  })
                }
                placeholder="Buffer percentage"
              />
              <Form.Text className="text-muted">
                Additional buffer amount as percent of total premium
              </Form.Text>
            </Form.Group>

            <Card className="mt-3 border-info">
              <Card.Header className="bg-info text-white">
                <small>
                  <span className="bi bi-lightbulb me-1"></span>Quick Tips
                </small>
              </Card.Header>
              <Card.Body className="py-2">
                <ul className="mb-0 small">
                  <li>Maternity cover typically for adults only</li>
                </ul>
              </Card.Body>
            </Card>
          </div>
        </div>
        {/* Special Notice for Universal Sompo */}
        {selectedInsurer ===
          "Universal Sompo General Insurance Company Limited" && (
            <Alert variant="success" className="mb-3">
              <Alert.Heading>Universal Sompo Selected</Alert.Heading>
              <p>
                You have selected Universal Sompo General Insurance Company
                Limited. The system will generate family members for each employee
                based on your maximum limits and calculate premiums using:
              </p>
              <ul className="mb-0">
                <li>
                  Per-employee family generation (identified by Employee ID)
                </li>
                <li>Zone-based pricing using pincode mapping</li>
                <li>Age band classification for accurate rating</li>
                <li>Family member relationships and coverage types</li>
                <li>Selected add-ons and buffer percentage</li>
              </ul>
            </Alert>
          )}
        {selectedInsurer &&
          selectedInsurer !==
          "Universal Sompo General Insurance Company Limited" && (
            <Alert variant="warning" className="mb-3">
              <strong>Note:</strong> Bulk quote generation is currently only
              available for Universal Sompo General Insurance Company Limited.
              Please select Universal Sompo to proceed with quote generation.
            </Alert>
          )}
        {/* Action Buttons */}
        <div className="row mb-4">
          <div className="col-md-12 text-end">
            <Button
              variant="secondary"
              className="me-2"
              onClick={() => window.location.reload()}
            >
              <span className="bi bi-x-square me-2"></span>
              Reset Form
            </Button>
            <Button
              style={{ marginTop: "0px" }}
              variant="primary"
              onClick={this.handleSubmitClick}
            // disabled={
            //   isProcessing ||
            //   this.state.selectedInsurer !==
            //     "Universal Sompo General Insurance Company Limited"
            // }
            >
              {isProcessing ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Processing...
                </>
              ) : (
                <>
                  <span className="bi bi-check2-square me-2"></span>
                  Generate Bulk Quote
                </>
              )}
            </Button>
          </div>
        </div>

        {/* Results Modal */}
        <Modal
          show={showResultsModal}
          onHide={() => this.setState({ showResultsModal: false })}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Bulk Quote Generation Results</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {quoteResults && (
              <div>
                <Alert variant="success">
                  <h6>Quote Generated Successfully!</h6>
                  <p className="mb-1">
                    <strong>Bulk Quote Request ID:</strong>{" "}
                    {quoteResults.bulkQuoteRequestId}
                  </p>
                  <p className="mb-1">
                    <strong>Total Members Processed:</strong>{" "}
                    {quoteResults.totalMembers}
                  </p>
                  <p className="mb-0">
                    <strong>Total Base Premium:</strong> ₹
                    {quoteResults.totalBasePremium?.toLocaleString()}
                  </p>
                </Alert>
                {quoteResults.processedMembers &&
                  quoteResults.processedMembers.length > 0 && (
                    <DataTable
                      data={quoteResults.processedMembers.map(
                        (member, index) => ({
                          id: member.memberId,
                          sno: index + 1,
                          name: member.memberFullName,
                          employeeId: member.employeeId,
                          relationship: member.relationshipWithEmployee,
                          sumInsured: member.sumInsured,
                          premium: member.premium,
                          status: member.status,
                        })
                      )}
                      columns={[
                        {
                          name: "Member Name",
                          selector: (row) => row.name,
                          sortable: true,
                        },
                        {
                          name: "Employee ID",
                          selector: (row) => row.employeeId,
                          sortable: true,
                        },
                        {
                          name: "Relationship",
                          selector: (row) => row.relationship,
                          sortable: true,
                        },
                        {
                          name: "Sum Insured",
                          selector: (row) => row.sumInsured,
                          sortable: true,
                          right: true,
                        },
                        {
                          name: "Premium",
                          selector: (row) => row.premium,
                          sortable: true,
                          right: true,
                        },
                      ]}
                      pagination
                      paginationPerPage={10}
                      paginationRowsPerPageOptions={[10, 20, 50, 100]}
                      className="table table-striped table-bordered dataTable no-footer"
                      keyField="id"
                    />
                  )}

                {quoteResults.summary && (
                  <Table striped bordered hover size="sm">
                    <thead>
                      <tr>
                        <th>Component</th>
                        <th className="text-end">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Base Premium</td>
                        <td className="text-end">
                          ₹
                          {quoteResults.summary.totalBasePremium?.toLocaleString()}
                        </td>
                      </tr>
                      <tr>
                        <td>Add-on Premiums</td>
                        <td className="text-end">
                          ₹
                          {(
                            quoteResults.summary.addonPremiums || 0
                          ).toLocaleString()}
                        </td>
                      </tr>
                      <tr>
                        <td>Sub Total</td>
                        <td className="text-end">
                          ₹{quoteResults.summary.subTotal?.toLocaleString()}
                        </td>
                      </tr>
                      <tr>
                        <td>GST (18%)</td>
                        <td className="text-end">
                          ₹{quoteResults.summary.gst?.toLocaleString()}
                        </td>
                      </tr>
                      <tr>
                        <td>Buffer ({this.state.bufferPercentage}%)</td>
                        <td className="text-end">
                          ₹{quoteResults.summary.buffer?.toLocaleString()}
                        </td>
                      </tr>
                      <tr className="table-success">
                        <td>
                          <strong>Grand Total</strong>
                        </td>
                        <td className="text-end">
                          <strong>
                            ₹{quoteResults.summary.grandTotal?.toLocaleString()}
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                )}

                <div className="mt-3 mb-3">
                  <Badge bg="info" className="me-2">
                    Adults: {quoteResults.memberCounts?.adults || 0}
                  </Badge>
                  <Badge bg="success" className="me-2">
                    Children: {quoteResults.memberCounts?.children || 0}
                  </Badge>
                  <Badge bg="warning" className="me-2">
                    Parents: {quoteResults.memberCounts?.parents || 0}
                  </Badge>
                </div>

                {/* Configuration Summary */}
                <Card className="mt-3">
                  <Card.Header className="bg-light">
                    <h6 className="mb-0">
                      <span className="bi bi-gear me-2"></span>
                      Bulk Configuration Applied
                    </h6>
                  </Card.Header>
                  <Card.Body className="py-2">
                    <div className="row">
                      <div className="col-md-6">
                        <strong>Sum Insured:</strong>
                        <br />
                        <small className="text-muted">
                          {bulkSumInsuredConfig.applyToAll
                            ? `₹${parseInt(
                              bulkSumInsuredConfig.allEmployeesSumInsured || 0
                            ).toLocaleString()} (All Employees)`
                            : "Custom per employee"}
                        </small>
                      </div>
                      <div className="col-md-6">
                        <strong>Add-ons Configuration:</strong>
                        <br />
                        <small className="text-muted">
                          {bulkAddonsConfig.applyToAll
                            ? "Same add-ons for all members"
                            : "Member-specific add-ons"}
                        </small>
                      </div>
                    </div>

                    {bulkAddonsConfig.applyToAll && (
                      <div className="mt-2">
                        <small>
                          <strong>Selected Add-ons: </strong>
                          {Object.entries(bulkAddonsConfig.allEmployeesAddons)
                            .filter(([_, selected]) => selected)
                            .map(([addon, _]) =>
                              addon
                                .replace(/([A-Z])/g, " $1")
                                .replace(/^./, (str) => str.toUpperCase())
                            )
                            .join(", ") || "None"}
                        </small>
                      </div>
                    )}
                  </Card.Body>
                </Card>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => this.setState({ showResultsModal: false })}
            >
              Close
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                this.setState({ showResultsModal: false });
                // Navigate to summary page
                window.location.href = "/generatesamplepage";
              }}
            >
              View Summary
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
